import { VerticalsValues } from '@/shared/types/verticals.ts';

export const useVerticals = () => {
  const route = useRoute();

  const vertical = computed(() => {
    const path = route.path;

    if (path.includes('/experience/')) {
      return VerticalsValues.EXCURSION;
    }

    if (path.includes('/tours/')) {
      return VerticalsValues.TOURS;
    }

    return VerticalsValues.DEFAULT;
  });

  return {
    vertical,
  };
};
